import React, { useEffect, useState,useRef   } from "react"
import MetaTags from 'react-meta-tags';
import Select from "react-select";
import moment from "moment";

import {
    Col,
    Row,
    Card,
    CardBody,
    Button,
    ButtonGroup,
    UncontrolledTooltip,
    Modal,
} from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next"
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import ReactToPrint from "react-to-print";
const { SearchBar } = Search;
import ReactBSAlert from "react-bootstrap-sweetalert";
import { connect } from "react-redux";
import paginationFactory from 'react-bootstrap-table2-paginator';

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";

import ViewImageModalComponent from '../ViolationLogs/ViewImageModal';
import EditViolationModalComponent from '../ViolationLogs/EditViolationModal'
import { ReportType, SearchData, SpeedType } from '../ViolationLogs/ViolationLogsComponents';

import {AllUsersListContext} from "components/Common/PageDataContext";

import UserRegistratinoModalComponent from './UserRegistration';
import DeleteUserModalComponent from "./DeleteUser";
import EditUserModalComponent from "./EditUser";
import ChangePasswordModalComponent from "./ChangePassword";
import { apiEndpoint } from "helpers/url_helper";

import jwt from "jsonwebtoken";

import Login from "../Authentication/Login"
import { authRoutes } from "routes/allRoutes";
import $ from 'jquery'; 
//Style
const btnstylesObj = {
    "marginTop": '2rem',
};

 // This is  custom csv export component
 const ExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
        <Button  size="sm" id="csv-tooltip"
        className="buttons-copy buttons-html5"
        color="dark" onClick={ handleClick }> 
        <span>Csv</span></Button>
    );
  };

const UsersTables = (props) => {
    //Print function
    const componentRef = useRef();
    const [Campusitems, setCampusItems] = useState([]);
    const [SelectedCampusitem, setSelectedCampusItem] = useState([]);
    const [selectedCampusVal, setCampusSelected] = useState();

    const [FromDtTm, setFrmDttm] = useState(moment().format("YYYY-MM-DD 00:00"));
    const [ToDtTm, setToDttm] = useState(moment().format("YYYY-MM-DD HH:mm"));

    const [FromSpeed, setFrmSpeed] = useState(20);
    const [ToSpeed, setToSpeed] = useState(100);
    const [BoolANPR, setANPR] = useState(true);

    const [selectedReportTypeVal, setReportType] = useState(1);
    const [selectedSpeedTypeVal, setSpeedType] = useState(1);

    const [adduser, setadduser] = useState();
    const [changepassword, setchangepassword] = useState();
    const [editdeleteuser, seteditdeleteuser] = useState();
    const SessionExpired = () => {
      console.log("SessionExpired Called");
      // need to redirect to login page
      // working on it
    }

    const breadcrumbItems = [
         { title: "User Management", link: "/UserManagement" },
    ]
    const [usersData, setUsersData] = useState([]);
    const Contextvalue = { usersData, setUsersData };
    const [alertmsg, setAlert] = useState([]);

    const columns = [
        {
          dataField: "UserID",
          text: "UserID",
          hidden: true
        },
      
        {
        dataField: "UserRole",
        text: "User Role",
        sort: true
        },
        {
            dataField: "UserName",
            text: "User Name",
            sort: true
        },
    
        {
            dataField: "UserFullName",
            text: "Full Name",
            sort: true
        },
    
        {
            dataField: "UserEmail",
            text: "Email ID",
        },
        {
            dataField: "UserContactNumber",
            text: "Contact",
            sort: true
        },
        {
            dataField: "UserRegistrationDate",
            text: "Registration Date",
        },
      
        {
             dataField: "UserID",
            text: "Edit",
            csvExport: false,
            sort: false,
            formatter: (value, row) => 
               (              
              <AllUsersListContext.Provider value={Contextvalue} >
                <EditUserModalComponent  UserID={value} UserData={row}/>
              </AllUsersListContext.Provider>
               ),
               hidden: !editdeleteuser
                },    
                
        {
          // dataField: "SendMail",
          text: "Change Password",
          csvExport: false,
          sort: false,
          formatter: (value, row) => (
              <ChangePasswordModalComponent UserID={value} UserData={row}/>
            ),
            hidden: !changepassword
        },
        {
          // dataField: "SendSMS",
          text: "Delete",
          csvExport: false,
          sort: false,
          formatter: (value, row) => (
              <AllUsersListContext.Provider value={Contextvalue}>
                <DeleteUserModalComponent UserID={value} UserData={row}/>
              </AllUsersListContext.Provider>
            ),
            hidden: !editdeleteuser
        },
        {
          dataField: "UserRoleID",
          
          hidden:true
      },
    ]
    const custompagination = paginationFactory({
        page: 1,
        alwaysShowAllBtns: true,
        showTotal: true,
        withFirstAndLast: false,
        sizePerPageRenderer: ({ options, currSizePerPage, onSizePerPageChange }) => (
          <div className="dataTables_length" id="datatable-basic_length">
            <label>
              Show{" "}
              {
                <select
                  name="datatable-basic_length"
                  aria-controls="datatable-basic"
                  className="form-control form-control-sm"
                  onChange={e => onSizePerPageChange(e.target.value)}
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              }{" "}
              entries.
            </label>
          </div>
        )
      });
    // Note: the empty deps array [] means
    // this useEffect will run once
    // similar to componentDidMount()
    useEffect(() => {
      const decodedToken = jwt.decode(sessionStorage.getItem("Clear_AuthUser"));
      var UserPermissions=JSON.parse(decodedToken.userRolePermissions);
      // var UserPermissions=JSON.parse(sessionStorage.getItem("UserRolePermissions"));

      setadduser(UserPermissions.AddUser)
      seteditdeleteuser(UserPermissions.EditDeleteUser)
      setchangepassword(UserPermissions.ChangePassword)

      // UserValidated
      fetch(apiEndpoint+"/GetAllUserList",
      {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          "Token": sessionStorage.getItem("Clear_AuthUser")
        })
      })
      .then(res => res.json())
      .then(
          (result) => {
              if(result!=undefined)
              {
                if(result.status){
                  //sessionStorage.setItem("authUser",JSON.stringify(result.strNewToken))
                  if(JSON.parse(result.Users).length>0)
                  setUsersData(JSON.parse(result.Users));
                  else
                  setUsersData([]);
                }
                else{
                  setAlert (
                    <ReactBSAlert
                      warning
                      title="Warning"
                      onConfirm={() => SessionExpired()}
                      onCancel={() => setAlert(null)}
                      confirmBtnBsStyle="info"
                    >
                      {result.Message}
                    </ReactBSAlert>
                  )
                }
              }
          },
          // Note: it's important to handle errors here
          // instead of a catch() block so that we don't swallow
          // exceptions from actual bugs in components.
          (error) => {
              //setError(error);
          }
      )
    
    }, [])

    const [Locitems, setLocItems] = useState([]);
    const [SelectedLocitem, setSelectedLocItem] = useState([]);
    const [selectedLocVal, setLocSelected] = useState();
  
    // this function will copy to clipboard an entire table,
    // so you can paste it inside an excel or csv file
    const copyToClipboardAsTable = el => {
      var body = document.body,
        range,
        sel;
      if (document.createRange && window.getSelection) {
        range = document.createRange();
        sel = window.getSelection();
        sel.removeAllRanges();
        try {
          range.selectNodeContents(el);
          sel.addRange(range);
        } catch (e) {
          range.selectNode(el);
          sel.addRange(range);
        }
        document.execCommand("copy");
      } else if (body.createTextRange) {
        range = body.createTextRange();
        range.moveToElementText(el);
        range.select();
        range.execCommand("Copy");
      }

      setAlert (
          <ReactBSAlert
            success
          //   style={bsAlertStyle}
          //   title="Good job!"
            onConfirm={() => setAlert(null)}
            onCancel={() => setAlert(null)}
            confirmBtnBsStyle="info"
          >
            Copied to clipboard!
          </ReactBSAlert>
        )
    }
    useEffect(() => {
        props.setBreadcrumbItems('User Management', breadcrumbItems);
        //SearchViolations();
    })
    return (
        <React.Fragment>

            <MetaTags>
                <title>Indus | User Management</title>
            </MetaTags>
            <AvForm className="needs-validation">
              <br></br>
            <Row>
              {adduser &&
                <Col md={12} style={{textAlign: "right"}} >
                  <AllUsersListContext.Provider value={Contextvalue}>
                    <UserRegistratinoModalComponent />
                  </AllUsersListContext.Provider>
                </Col>}
            </Row>
            </AvForm>
            <Row className="mt-3">
                <Col>
                    <Card>
                        <CardBody>
                            
                            <div className="table-responsive mt-2">
                             {alertmsg}
                            <ToolkitProvider
                                    keyField="RecordID"
                                    data={usersData}
                                    columns={columns}
                                    exportCSV={{
                                        fileName: "file.csv",
                                    }}
                                    search
                                >
                                    {
                                        props => (
                                            <div>                          
                <Row>
                  <Col xs={12} sm={6}>
                    <ButtonGroup>
                        <ExportCSV { ...props.csvProps }  />
                        &nbsp;                 
                      <Button
                        className="buttons-copy buttons-html5"
                        color="dark"
                        size="sm"
                        id="copy-tooltip"
                        onClick={() =>
                          copyToClipboardAsTable(
                            document.getElementById("react-bs-table")
                          )
                        }
                      >
                        <span>Copy</span>
                      </Button>
                      &nbsp;  
                      <ReactToPrint
                        trigger={() => (
                          <Button
                            color="dark"
                            size="sm"
                            className="buttons-copy buttons-html5"
                            id="print-tooltip"
                          >
                           <span>Print</span> 
                          </Button>
                        )}
                        content={() => componentRef.current}
                      />
                    </ButtonGroup>
                    <UncontrolledTooltip placement="top" target="print-tooltip">
                      This will open a print page with the visible rows of the
                      table.
                    </UncontrolledTooltip>
                    <UncontrolledTooltip placement="top" target="copy-tooltip">
                      This will copy to your clipboard the visible rows of the
                      table.
                    </UncontrolledTooltip>
                    <UncontrolledTooltip placement="top" target="csv-tooltip">
                      This will download table data in csv file.
                    </UncontrolledTooltip>
                  </Col>
                  <Col xs={12} sm={6}>
                    <div
                      id="datatable-basic_filter"
                      className="dataTables_filter px-4 pb-1 float-right"
                    >
                      <label>  
                        <SearchBar
                          className="form-control-sm"
                          placeholder=""
                          {...props.searchProps}
                        />
                      </label>
                    </div>
                  </Col>
                </Row>
            <BootstrapTable id="react-bs-table" 
             ref={componentRef}
            { ...props.baseProps }  
            // bootstrap4={true}
            pagination={paginationFactory({sizePerPage: 10})}/> 
                                                
            </div>
                                        )
                                    }
                            </ToolkitProvider>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
<Row>
</Row>
        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(UsersTables);
